import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=4fa9d448"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"
import style0 from "./MapLegend.vue?vue&type=style&index=0&id=4fa9d448&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports